exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-select[data-v-b0d5461a] {\n  display: block;\n}", ""]);

// exports
